export const ASSET_FILE_EXTENSIONS = {
  image: ['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'svg'],
  video: ['mp4', 'mov', 'avi', 'mkv', 'webm', 'flv', 'wmv'],
  document: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv'],
  archive: ['zip', 'rar', '7z', 'tar', 'gz']
};

/**
 * 获取文件扩展名（小写，不带点）
 */
export function getFileExtension(fileName?: string | null): string {
  const normalizedName = (fileName || '').trim().toLowerCase();
  const dotIndex = normalizedName.lastIndexOf('.');

  if (dotIndex === -1 || dotIndex === normalizedName.length - 1) {
    return '';
  }

  return normalizedName.slice(dotIndex + 1);
}

/**
 * 根据文件名或 MIME 类型确定文件类型枚举 (IMAGE | VIDEO | DOCUMENT | ARCHIVE | OTHER)
 */
export function getAssetFileType(fileName?: string | null, mimeType?: string | null): Api.Upload.UploadFileType {
  const ext = getFileExtension(fileName);
  const mime = (mimeType || '').toLowerCase();

  if (mime.startsWith('image/') || ASSET_FILE_EXTENSIONS.image.includes(ext)) {
    return 'IMAGE';
  }

  if (mime.startsWith('video/') || ASSET_FILE_EXTENSIONS.video.includes(ext)) {
    return 'VIDEO';
  }

  if (
    mime.startsWith('application/pdf') ||
    mime.includes('document') ||
    mime.includes('sheet') ||
    mime.includes('presentation') ||
    mime.startsWith('text/') ||
    ASSET_FILE_EXTENSIONS.document.includes(ext)
  ) {
    return 'DOCUMENT';
  }

  if (
    mime.includes('zip') ||
    mime.includes('compressed') ||
    mime.includes('archive') ||
    mime.includes('tar') ||
    ASSET_FILE_EXTENSIONS.archive.includes(ext)
  ) {
    return 'ARCHIVE';
  }

  return 'OTHER';
}
